module.exports = __webpack_public_path__ + "img/category_92.e44cb6b9.jpg";